import ConfirmMixin from "../mixins/confirm-mixin";

export default {
    mixins: [ConfirmMixin],
    methods: {
        resendConfirmCode() {
            //todo: удалить
            console.log('confirmPhoneForRegister')

            this.clearErrors();

            this.$store.dispatch('resendMobilePhoneConfirmationCode')
                .then((response) => {
                    if (response.status === 'success') {
                        this.startTimer()
                    }
                })
                .catch((errors) => {
                    this.processErrors(errors)
                })
        },
        confirmCode() {
            //todo: удалить
            console.log('confirmPhoneForRegister')

            this.clearErrors();

            this.$store.dispatch('confirmMobilePhone', this.code)
                .then((response) => {
                    if (response.status === 'success') {
                        this.$store.commit('setStep', 'register')
                    }
                })
                .catch((errors) => {
                    this.processErrors(errors)
                })
        }
    }
}